import { field, readContract, writeContractAndWait } from "../viem";
import config from "../../config/config";
import MafiaStoryModeAbi from "../../abis/MafiaStoryMode.json";

const address = config.storyMode;
const abi = MafiaStoryModeAbi;

export const getStoryModeUserMissionStatus = async (account: string) => {
  const data: any = await readContract({
    address,
    abi,
    functionName: "getUserMissionStatus",
    args: [account],
  });
  return {
    currentStage: Number(field(data, "currentStage", 0)),
    isStarted: field(data, "isStarted", 1),
    startedAt: Number(field(data, "startedAt", 2)),
    isMissionCompleted: field(data, "isMissionCompleted", 3),
    completedAt: (field(data, "completedAt", 4) || []).map((item: any) => Number(item)),
  };
};

export const claimStoryModeReward = async (account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "claimReward",
    account,
  });
  return data;
};

export const claimMysteryBox = async (account: string, itemId: number) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "claimMysteryBox",
    args: [itemId],
    account,
  });
  return data;
};
